<div 
   [ngClass]="{
      'custom_main_wrapper': isSidebarDisplayed && !isSidebarOpen,
      'no_sidebar': !isSidebarDisplayed
   }"
   id="main_wrapper"
>
   <app-top-header *ngIf="layoutService.headerVisible$ | async"></app-top-header>
   <app-banner-trading-announcement></app-banner-trading-announcement>
   <ng-content></ng-content>
   <app-latest-footer *ngIf="layoutService.footerVisible$ | async"></app-latest-footer>
   <app-log-out-modale></app-log-out-modale>
</div>
<app-sidebar-menu *ngIf="layoutService.sidebarVisible$ | async"></app-sidebar-menu>